import styled from '@emotion/styled'
import { Button, Grid, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { sendMessageToDB } from '../utils/fetchDB'
import useRwd from '../utils/useRwd'
import { sendCustomerMessage } from '../utils/mail'
import swal from 'sweetalert'

const StyledTextField = styled(TextField)`
  font-family: GenYOGothic2TW;
  background-color: #1b86ce;
  color: #ffffff;

  & .MuiInputLabel-root {
    color: #ffffff;
    font-size: 1.2rem;
    font-weight: bold;
  }

  & .MuiInputLabel-root.Mui-focused {
    color: #ffffff;
    font-weight: bold;
    font-size: 1rem;
  }

  & .MuiInputBase-input {
    color: #ffffff;
    font-size: 1.2rem;
  }

  & .MuiAutocomplete-inputRoot {
    background-color: #1b86ce;
    color: #ffffff;
  }
`
const StyledButton = styled(Button)`
  font-family: GenYOGothic2TW;
  background-color: #045ea8;
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: regular;
  border-radius: 1.5em;
  padding: 0.4em 1em;

  &:hover {
    color: #045ea8;
    border-color: #045ea8;
    background-color: #ffffff;
  }
`

const initFormValue = {
  company_name: '',
  name: '',
  email: '',
  message: '',
}
export default function ContactMe() {
  const [form, setForm] = useState(initFormValue)
  const { isPhone } = useRwd()

  function handleChange(e) {
    setForm({ ...form, [e.target.id]: e.target.value })
  }
  async function handleSubmit(e) {
    e.preventDefault()
    try {
      await sendMessageToDB(form)
      await sendCustomerMessage(form)
      swal({
        title: '感謝您的填寫！我們將盡快與您聯絡',
        icon: 'success',
      })
    } catch (error) {
      swal({
        title: '寄送失敗',
        icon: 'error',
      })
      console.error(error)
    } finally {
      setForm(initFormValue)
    }
  }

  return (
    <div style={{ width: isPhone ? '100%' : '80%', margin: '5em auto' }}>
      <Typography variant="h3">聯繫我們</Typography>
      <form id="contact_form" style={{ width: '100%' }} onSubmit={handleSubmit}>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: '2em' }}
        >
          <Grid item xs={12}>
            <StyledTextField
              variant="filled"
              id="company_name"
              name="company_name"
              label="公司名稱"
              size="auto"
              value={form.company_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              variant="filled"
              id="name"
              name="name"
              label="姓名"
              size="auto"
              value={form.name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              variant="filled"
              id="email"
              name="email"
              label="電子信箱"
              size="auto"
              value={form.email}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              variant="filled"
              id="message"
              name="message"
              label="請在這裡輸入您的訊息"
              value={form.message}
              onChange={handleChange}
              multiline
              fullWidth
              minRows={10}
              maxRows={20}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <StyledButton type="submit" variant="contained">
              送出
            </StyledButton>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}
